export default {
    name: 'clickoutside',
    directive: {
        bind: function(el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                if (!(el == event.target || el.contains(event.target))) {
                    if (binding.value == undefined) {
                        vnode.context[binding.arg](binding?.value)
                    }
                    else {
                        vnode.context[binding.arg](binding?.value, event)
                    }
                }
            }
            document.body.addEventListener('click', el.clickOutsideEvent)
            document.body.addEventListener('touchstart', el.clickOutsideEvent)
            // console.log('click-outside inserted')
        },
        unbind:function(el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
            document.body.removeEventListener('touchstart', el.clickOutsideEvent)
            // console.log('click-outside unbind')
        },
        stopProp(event) {
            event.stopPropagation()
        },
    }
}